import { BoxUniqueFeatureModalProduct } from '@jusbrasil-web/shared-feature-locker'

export const BOX_MODAL_IFRAME_URL = '/web/docview/iframe-box/modal'
export const BOX_PAYWALL_IFRAME_URL = '/web/docview/iframe-box/paywall'
export const DOCUMENT_REPORT_IFRAME_URL = '/web/docview/iframe-document-report'
export const DOCUMENT_MODERATION_MODAL_IFRAME_URL = '/web/docview/iframe-document-moderation-modal'

export const FEATURE_CODES = {
  COPY_JURIS_CONTENT: 'copy_juris_content',
  DOWNLOAD_JURIS_CONTENT: 'download_juris_content',
  LEGAL_QUOTE: 'legal_quote',
  ABNT_QUOTE: 'abnt_quote_doctrine',
  LINK_DOCS_PROCESSO: 'link_docs_processo',
  UNLOCK_CASE_LAW_INFORMATION: 'unlock_case_law_information',
  DOWNLOAD_MODELOS_CONTENT: 'download_modelos_content',
  DOWNLOAD_PECAS_CONTENT: 'download_pecas_content',
  COPY_MODELOS_CONTENT: 'copy_modelos_content',
  COPY_DOCTRINE_CONTENT: 'copy_doctrine_content',
  COPY_PECAS_CONTENT: 'copy_pecas_content',
  VIEW_LR_CONTENT: 'view_lr_content',
  VIEW_LR_CONTENT_1000: 'view_lr_content_1000',
  VIEW_DOCTRINE_CONTENT: 'view_doctrine_content',
  DOWNLOAD_DIARIOS_CONTENT: 'download_diarios_content',
  VIEW_THESIS_AND_FACTS_CONTENT: 'view_thesis_and_facts',
  VIEW_RELATED_SUMMARY_CONTENT: 'view_related_summary',
  VIEW_RELATED_LEGIS_CONTENT: 'view_related_legis',
} as const

export type FeatureCode = (typeof FEATURE_CODES)[keyof typeof FEATURE_CODES]

export const JUSBRASIL_HOTJAR_SITE_ID = 2471547

export const DATE_FORMATTER = new Intl.DateTimeFormat('pt-BR')

export const ARTIFACT_LABELS = {
  JURISPRUDENCIA: {
    path: 'jurisprudencia',
    pluralLabel: 'Jurisprudências',
    singularLabel: 'Jurisprudência',
    preposition: 'da',
  },
  NAO_IDENTIFICADO: {
    path: 'jurisprudencia',
    pluralLabel: 'Jurisprudência',
    singularLabel: 'Jurisprudência',
    preposition: 'da',
  },
  INTEIRO_TEOR: {
    path: 'inteiro-teor',
    pluralLabel: 'Inteiros Teores',
    singularLabel: 'Inteiro Teor',
    preposition: 'do',
  },
  ORIENTACAO_JURISPRUDENCIAL: {
    path: 'orientacoes-jurisprudenciais',
    pluralLabel: 'Orientações Jurisprudências',
    singularLabel: 'Orientação Jurisprudencial',
    preposition: 'da',
  },
  SUMULA: {
    path: 'sumulas',
    pluralLabel: 'Súmulas',
    singularLabel: 'Súmula',
    preposition: 'da',
  },
  ARTIGO: {
    path: 'artigos',
    pluralLabel: 'Artigos',
    singularLabel: 'Artigo',
    preposition: 'do',
  },
  MODELO_PECA: {
    path: 'modelos-pecas',
    pluralLabel: 'Modelos',
    singularLabel: 'Modelo',
    preposition: 'do',
  },
  NOTICIAS: {
    path: 'noticias',
    pluralLabel: 'Notícias',
    singularLabel: 'Notícia',
    preposition: 'da',
  },
  PECA: {
    path: 'processos',
    pluralLabel: 'Peças',
    singularLabel: 'Peça',
    preposition: 'da',
  },
  DOUTRINA: {
    path: 'doutrina',
    pluralLabel: 'Doutrinas',
    singularLabel: 'Doutrina',
    preposition: 'da',
  },
  SECAO_DOUTRINA: {
    path: 'doutrina/secao',
    pluralLabel: 'Seções Doutrinas',
    singularLabel: 'Seção Doutrina',
    preposition: 'da',
  },
  LEGISLACAO: {
    path: 'legislacao',
    pluralLabel: 'Legislações',
    singularLabel: 'Legislação',
    preposition: 'da',
  },
  DIARIO: {
    path: 'diarios',
    pluralLabel: 'Diários',
    singularLabel: 'Diário',
    preposition: 'do',
  },
} as const

export const ARTIFACT_LABEL = {
  JURISPRUDENCIA: 'JURISPRUDENCIA',
  INTEIRO_TEOR: 'INTEIRO_TEOR',
  NAO_IDENTIFICADO: 'NAO_IDENTIFICADO',
  ORIENTACAO_JURISPRUDENCIAL: 'ORIENTACAO_JURISPRUDENCIAL',
  SUMULA: 'SUMULA',
  MODELO_PECA: 'MODELO_PECA',
  PECA: 'PECA',
  ARTIGO: 'ARTIGO',
  NOTICIAS: 'NOTICIAS',
  DOUTRINA: 'DOUTRINA',
  SECAO_DOUTRINA: 'SECAO_DOUTRINA',
  LEGISLACAO: 'LEGISLACAO',
  DIARIOS: 'DIARIOS',
  BLOCO_DIARIO: 'BLOCO_DIARIO',
  COMENTARIO: 'COMENTARIO',
} as const

export const DOCTRINE_BOX_PRODUCT = 'doctrine' as BoxUniqueFeatureModalProduct
export const JURIS_BOX_PRODUCT = 'juris' as BoxUniqueFeatureModalProduct

export const RELATED_LEGIS_COMPONENT_HEADING_COPY = 'Vide legislação relacionada sobre'

export const TERM_TYPE = {
  Processo: 'Processo',
  Nome: 'Nome',
} as const

export const APP_ID = 'web-docview'

export const URL_JUSIA = 'https://ia.jusbrasil.com.br/conversa'
